import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _regeneratorRuntime from "@babel/runtime/regenerator";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { RoleSelector as rsCore, miloCore } from '@tencent/milo-core';
import RelationSelector from '../util/relationSelector';
import roleselectorTpl from './roleselectorTpl.js';
import './roleselector.css';
import { findNodeByClass, _$, appendHtml } from '../util/domHelper';
import { miloAlert } from '../AlertDialog/index.js';
var defaultConfig = {
  gameId: '',
  openToOpen: {},
  renderStyle: '',
  // 自定义渲染的样式，css
  charset: 'utf8',
  sRoleInfoUrl: '',
  // 自定义请求接口(如上云等)
  channelContentId: 'channelContentId',
  systemContentId: 'systemContentId',
  area1ContentId: 'area1ContentId',
  areaContentId: 'areaContentId',
  roleContentId: 'roleContentId',
  confirmButtonId: 'confirmButtonId',
  type: 'float',
  filterChannel: 'no',
  // 是否过滤渠道，可选值:wx   qq    auto(根据登录态自动)   no(默认)
  filterSystem: 'no',
  // 是否过滤系统，可选值：ios  android  auto(根据userAgent判断)  no(默认)
  onError: '',
  // 选角色过程中出现错误
  onSubmit: '',
  // 用户点击确认按钮
  onClose: '',
  // 用户点击关闭按钮，作用于float
  onCancel: '',
  // 用户点击取消按钮，作用于float
  onSerial: '' // 提供监听流水号获取 add by weiztang 20220824

};

var RoleSelectorComponent = /*#__PURE__*/function () {
  function RoleSelectorComponent(option) {
    _classCallCheck(this, RoleSelectorComponent);

    this.config = _objectSpread(_objectSpread({}, defaultConfig), option); // renderKey,每一个实例特有的

    this.renderData = {
      renderKey: '',
      relationSelector: null
    };
    this.renderData.renderKey = "".concat(this.config.gameId, "_").concat(Math.ceil(Math.random() * 10000), "_").concat(new Date().getTime());
    this.roleData = {
      // areaArray: [],
      areaIndex: [],
      // 当前选中的序号组
      areaFields: [],
      // 当前角色信息
      // 格式:

      /*
      {
      roleId:'',
      roleName:'',
      roleJob:'',
      roleSex:'',
      roleLevel:'',
      areaName:'',
      checkParam:'',
      md5str:'',
      area:'',
      platid:'',
      partition:''
      }
      */
      roleArray: [],
      // 原始大区配置信息
      oriAreaData: {},
      // 格式化之后的大区配置信息
      formatedAreaData: {}
    }; // this.errHint = ''
    // this.getAreaInfo()
    // 增加queryRoleByParams暴露

    this.queryRoleByParams = function () {
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return rsCore.queryRoleByParams.apply(null, args);
    };
  }

  _createClass(RoleSelectorComponent, [{
    key: "init",
    value: function () {
      var _init = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var self, _yield$rsCore$getArea, areaFields, formatedAreaData, areaIndex;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                self = this;
                _context.prev = 1;
                _context.next = 4;
                return rsCore.getAreaData(this.config);

              case 4:
                _yield$rsCore$getArea = _context.sent;
                areaFields = _yield$rsCore$getArea.areaFields;
                formatedAreaData = _yield$rsCore$getArea.formatedAreaData;
                areaIndex = areaFields.map(function () {
                  return 'empty';
                });
                self.roleData = _objectSpread(_objectSpread({}, this.roleData), {}, {
                  areaFields: areaFields,
                  areaIndex: areaIndex,
                  formatedAreaData: formatedAreaData
                });
                self.render(areaIndex);
                return _context.abrupt("return", self);

              case 13:
                _context.prev = 13;
                _context.t0 = _context["catch"](1);
                console.log(_context.t0);
                throw '大区配置获取失败，请检查网络和传入业务是否正确';

              case 17:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[1, 13]]);
      }));

      function init() {
        return _init.apply(this, arguments);
      }

      return init;
    }() // 渲染

  }, {
    key: "render",
    value: function render(areaIndex) {
      var self = this; // rsCore.setPIPInfo({
      //   gameId: self.config.gameId,
      //   action:'cancel'
      // });
      // 个保自定义关闭开关

      if (window.iCloseMiloPIP === 0) {// console.log('iCloseMiloPIP=0'); // 等于0的时候、不配置的时候都是默认开启的
      } else {
        // msdk环境下默认不进行PIP
        if (/msdk/i.test(window.navigator.userAgent)) {
          window.iCloseMiloPIP = 1;
        }
      }

      if (self.renderData.relationSelector) {
        // 已经初始化了
        self.renderData.relationSelector.setVal(areaIndex);
        self.doQueryRole();
        return;
      } // console.log('areaIndex',areaIndex);


      var _this$roleData = this.roleData,
          areaFields = _this$roleData.areaFields,
          formatedAreaData = _this$roleData.formatedAreaData;
      var arrSelectors = [];
      var fieldKey2Ele = {
        area: 'channelContentId',
        platid: 'systemContentId',
        partition: 'areaContentId',
        server: 'area1ContentId'
      }; // html模式下隐藏不需要的大区信息逻辑，暂保留
      // if ('html' == this.config.type) {
      //   Object.values(fieldKey2Ele).forEach(field => {
      //     _$(this.config[field]).style.display = 'none'
      //   })
      // }

      for (var i = 0; i < areaFields.length; i++) {
        arrSelectors.push({
          keyShow: 't',
          keyValue: 'v',
          keySub: function keySub(item, selOrder) {
            // console.log(item,selOrder);
            if ('empty' == item.v) {
              return [{
                v: 'empty',
                t: "\u8BF7\u9009\u62E9".concat(areaFields[selOrder + 1] && areaFields[selOrder + 1].fieldName || '')
              }];
            }

            return item.subData && item.subData.data;
          }
        });
        var fieldKey = areaFields[i].fieldKey;

        if ('html' == this.config.type) {
          // html模式下隐藏不需要的大区信息逻辑，暂保留
          // _$(this.config[fieldKey2Ele[fieldKey]]).style.display = 'block'
          arrSelectors[i].ele = this.config[fieldKey2Ele[fieldKey]];
        } else {
          arrSelectors[i].ele = "".concat(this.renderData.renderKey, "_").concat(fieldKey2Ele[fieldKey]);
        }
      }

      if ('float' == this.config.type) {
        // 创建相关的弹层和DOM
        var roleselectorHtml = roleselectorTpl.replace(/\{renderKey\}/g, this.renderData.renderKey);
        this.renderData.$selector = appendHtml(document.body, roleselectorHtml, "".concat(this.renderData.renderKey, "_roleselector"), 'roleselector-frame');
        this.renderData.$selector.style.display = 'none'; // 隐藏相关的select

        var $selector = this.renderData.$selector; // console.log('renderData', this.renderData);

        var rsBox = findNodeByClass($selector, 'roleselector-box');
        var rsRoleBox = findNodeByClass($selector, 'rb-role')[0];
        rsBox.forEach(function (item) {
          return item.style.display = 'none';
        });
        rsRoleBox.style.display = 'block';

        for (var _i = 0; _i < areaFields.length; _i++) {
          var areaField = findNodeByClass($selector, "rb-".concat(areaFields[_i].fieldKey))[0];
          areaField.style.display = 'block';
        }
      }

      this.renderData.relationSelector = new RelationSelector({
        selectors: arrSelectors,
        def: '',
        onChange: function onChange(arrIndex, order) {
          // console.log('选中：',arrIndex);
          self.roleData = _objectSpread(_objectSpread({}, self.roleData), {}, {
            areaIndex: arrIndex
          }); // 清空角色

          self.clearRole();

          if (order == arrIndex.length - 1 && 'empty' != arrIndex[arrIndex.length - 1]) {
            self.doQueryRole();
          }
        },
        data: formatedAreaData.data,
        initVal: areaIndex
      });
      self.doQueryRole(); // 绑定相关事件

      this.bindRenderEvent();
    }
  }, {
    key: "bindRenderEvent",
    value: function bindRenderEvent() {
      var _this = this;

      var self = this;
      var $confirmBtn = null;
      var $cancelBtn = null;
      var $pipTipsBox = null; // console.log('config', self.config);
      // console.log('roleData', self.roleData);

      if ('float' == self.config.type) {
        $confirmBtn = findNodeByClass(self.renderData.$selector, 'btn-confirm')[0];
        $cancelBtn = findNodeByClass(self.renderData.$selector, 'btn-cancel')[0]; // float下隐私许可框

        $pipTipsBox = findNodeByClass(self.renderData.$selector, 'roleselector-policy-tips')[0];
      } else {
        $confirmBtn = _$(self.config.confirmButtonId);
      } // 确认事件


      if ($confirmBtn) {
        $confirmBtn.onclick = function () {
          function afterPIP(self) {
            // 判断是否选择了角色
            var roleArray = self.roleData.roleArray;
            var roleId = '';

            if (roleArray && roleArray.length) {
              if ('float' == self.config.type) {
                roleId = _$("".concat(self.renderData.renderKey, "_roleContentId")).value;
              } else {
                roleId = _$(self.config.roleContentId).value;
              }
            } else {
              self.showMessage('请先选择角色', 'warn');

              if (self.config.onError) {
                self.config.onError('请先选择角色');
              }

              return;
            }

            var gameId = self.config.gameId;

            for (var i = 0; i < roleArray.length; i++) {
              if (roleId == roleArray[i].roleId) {
                self.config.onSubmit && self.config.onSubmit(_objectSpread({
                  gameId: gameId
                }, roleArray[i]));
                self.hide();
                break;
              }
            }
          }

          if ('float' == self.config.type) {
            // 隐私勾选逻辑
            var pipStatus = _$("".concat(self.renderData.renderKey, "_milo_policy_allow_status")).getAttribute('data-checked');

            if (pipStatus == 0) {
              self.showMessage('请勾选上方授权信息', 'warn');
              return;
            }

            rsCore.setPIPInfo({
              gameId: self.config.gameId
            });
            afterPIP(self);
          } else if ('html' == self.config.type) {
            if (!window.iCloseMiloPIP) {
              // 需要个保逻辑
              rsCore.getPIPInfo({
                gameId: self.config.gameId
              }).then(function (res) {
                // 等于0的时候代表已授权，不做处理；-10001时通常为没有登录态，亦不处理
                if (0 !== res.retCode && -10001 !== res.retCode) {
                  miloAlert({
                    title: '提示',
                    message: miloCore.isString(window.sCustomTipsMiloPIP) ? window.sCustomTipsMiloPIP : '我同意“本活动获取并存储到的游戏区服和角色相关信息，仅用于该活动的抽奖、领取、发货、签到等操作”',
                    cancelTitle: '拒绝',
                    confirmTitle: '授权',
                    onCancel: function onCancel() {
                      console.log('用户点击拒绝授权');
                    },
                    onConfirm: function onConfirm() {
                      rsCore.setPIPInfo({
                        gameId: self.config.gameId
                      });
                      afterPIP(self);
                    },
                    onClose: function onClose() {
                      console.log('用户关闭授权界面');
                    }
                  });
                } else {
                  afterPIP(self);
                }
              });
            } else {
              afterPIP(self);
            }
          }
        };
      }

      if ($cancelBtn) {
        // 取消事件
        $cancelBtn.onclick = function () {
          self.hide();
        }; // 关闭弹窗

      }

      if ('float' == self.config.type) {
        if (!window.iCloseMiloPIP) {
          if ($pipTipsBox) {
            var $pipTipsText = findNodeByClass(self.renderData.$selector, 'roleselector-policy-allow-text')[0];
            $pipTipsText.innerHTML = miloCore.isString(window.sCustomTipsMiloPIP) ? window.sCustomTipsMiloPIP : '我同意“本活动获取并存储到的游戏区服和角色相关信息，仅用于该活动的抽奖、领取、发货、签到等操作”';
            var areaFields = this.roleData.areaFields;

            $pipTipsBox.onclick = function () {
              var $pipStatus = _$("".concat(self.renderData.renderKey, "_milo_policy_allow_status"));

              if ($pipStatus.getAttribute('data-checked') == 0) {
                // 目前状态是未选中，设置为选中状态
                $pipStatus.setAttribute('data-checked', 1);
                $pipStatus.style.display = 'block'; // 移除select disable

                for (var i = 0; i < areaFields.length; i++) {
                  var areaFieldsSelect = findNodeByClass(_this.renderData.$selector, "rb-".concat(areaFields[i].fieldKey))[0].getElementsByTagName('select')[0];
                  areaFieldsSelect.removeAttribute('disabled');
                } // 角色也要移除disable


                var roleSelect = findNodeByClass(_this.renderData.$selector, 'rb-role')[0].getElementsByTagName('select')[0];
                roleSelect.removeAttribute('disabled');
              } else {
                $pipStatus.setAttribute('data-checked', 0);
                $pipStatus.style.display = 'none'; // 增加select disable

                for (var _i2 = 0; _i2 < areaFields.length; _i2++) {
                  var _areaFieldsSelect = findNodeByClass(_this.renderData.$selector, "rb-".concat(areaFields[_i2].fieldKey))[0].getElementsByTagName('select')[0];

                  _areaFieldsSelect.setAttribute('disabled', 'disabled');
                } // 角色也要增加disable


                var _roleSelect = findNodeByClass(_this.renderData.$selector, 'rb-role')[0].getElementsByTagName('select')[0];

                _roleSelect.setAttribute('disabled', 'disabled');
              }
            };
          }
        } else {
          $pipTipsBox.style.display = 'none';
          var _areaFields = this.roleData.areaFields;

          var $pipStatus = _$("".concat(self.renderData.renderKey, "_milo_policy_allow_status"));

          $pipStatus.setAttribute('data-checked', 1);
          $pipStatus.style.display = 'block'; // 移除select disable

          for (var i = 0; i < _areaFields.length; i++) {
            var areaFieldsSelect = findNodeByClass(this.renderData.$selector, "rb-".concat(_areaFields[i].fieldKey))[0].getElementsByTagName('select')[0];
            areaFieldsSelect.removeAttribute('disabled');
          } // 角色也要移除disable


          var roleSelect = findNodeByClass(this.renderData.$selector, 'rb-role')[0].getElementsByTagName('select')[0];
          roleSelect.removeAttribute('disabled');
        }
      } else if ('html' == self.config.type) {} // 隐私策略事件 - float

    }
  }, {
    key: "doQueryRole",
    value: function doQueryRole() {
      var self = this; // 查询角色

      var _self$config = self.config,
          openToOpen = _self$config.openToOpen,
          gameId = _self$config.gameId,
          sRoleInfoUrl = _self$config.sRoleInfoUrl,
          charset = _self$config.charset;
      var _self$roleData = self.roleData,
          areaIndex = _self$roleData.areaIndex,
          areaFields = _self$roleData.areaFields,
          formatedAreaData = _self$roleData.formatedAreaData;
      var isQuery = true;

      for (var i = 0; i < areaIndex.length; i++) {
        if ('empty' == areaIndex[i]) {
          isQuery = false;
          break;
        }
      }

      if (!isQuery) {
        return;
      }

      var oQueryParams = {
        openToOpen: openToOpen,
        gameId: gameId,
        request: {},
        areaIndex: areaIndex,
        sRoleInfoUrl: sRoleInfoUrl,
        charset: charset
      };

      for (var _i3 = 0; _i3 < areaFields.length; _i3++) {
        var requestKey = areaFields[_i3].requestKey;
        var curAreaIndex = areaIndex[_i3];
        oQueryParams.request[requestKey] = curAreaIndex; // if(requestKey === 'area' ) {
        //   const areaDatas = formatedAreaData.data
        //   if(areaDatas && areaDatas.length) {
        //     const curAreaData = areaDatas.find((x)=>x.v === curAreaIndex) 
        //     oQueryParams.request.areaname = curAreaData ? curAreaData.t : ''
        //   }
        // }
      }

      rsCore.queryRoleByParams(oQueryParams).then(function (result) {
        // console.log(result);

        /* result:{
        iRet:0,
        sMsg:'OK',
        retCode:'',//角色查询返回值
        roleData:<Array>
        }*/
        if (0 == result.iRet) {
          // 获取到数据了
          self.showMessage('');
          var roleArray = result.roleArray;
          self.roleData = _objectSpread(_objectSpread({}, self.roleData), {}, {
            roleArray: roleArray
          });
          var roleHtml = ''; // 渲染角色

          for (var _i4 = 0; _i4 < roleArray.length; _i4++) {
            roleHtml += "<option value=".concat(roleArray[_i4].roleId).concat(0 == _i4 ? ' selected' : '', ">").concat(roleArray[_i4].roleName, "</option>");
          }

          if ('float' == self.config.type) {
            _$("".concat(self.renderData.renderKey, "_roleContentId")).innerHTML = roleHtml;
          } else {
            _$(self.config.roleContentId).innerHTML = roleHtml;
          }
        } else {
          self.showMessage(result.sMsg || '当前区服未查询到角色', 'warn');
          self.clearRole();

          if (self.config.onError) {
            self.config.onError(result.sMsg || '当前区服未查询到角色', result);
          }
        }

        if (self.config.onSerial) {
          self.config.onSerial(result);
        }
      })["catch"](function (err) {
        self.showMessage(err.sMsg || '当前区服未查询到角色', 'warn');

        if (self.config.onError) {
          self.config.onError(err, self);
        }
      });
    } // 清除当前角色

  }, {
    key: "clearRole",
    value: function clearRole() {
      var self = this;
      this.roleData = _objectSpread(_objectSpread({}, this.roleData), {}, {
        roleArray: null
      });

      if ('float' == self.config.type) {
        _$("".concat(self.renderData.renderKey, "_roleContentId")).innerHTML = '';
      } else {
        _$(self.config.roleContentId).innerHtml = '';
      }
    }
  }, {
    key: "showMessage",
    value: function showMessage(msg, level) {
      if ('float' == this.config.type) {
        var msgContainer = findNodeByClass(this.renderData.$selector, 'roleselector-msg')[0];

        if (msg && msgContainer) {
          msgContainer.innerText = msg;

          if ('warn' == level) {
            msgContainer.style.color = '#ff9800';
          } else if ('error' == level) {
            msgContainer.style.color = '#f00';
          } else {
            msgContainer.style.color = '#2096f3';
          }

          msgContainer.style.display = 'block';
        } else {
          msgContainer.style.display = 'none';
        }
      }
    } // 弹出角色选择框

  }, {
    key: "show",
    value: function show() {
      if ('float' == this.config.type) {
        this.renderData.$selector.style.display = 'block';
      }

      this.showMessage('');
    } // 隐藏角色选择框

  }, {
    key: "hide",
    value: function hide() {
      if ('float' == this.config.type) {
        this.renderData.$selector.parentNode.removeChild(this.renderData.$selector);
      }
    }
  }]);

  return RoleSelectorComponent;
}();

export { RoleSelectorComponent as default };
export var selectRole = function selectRole(option) {
  var rs = new RoleSelectorComponent(option);
  rs.init().then(function (roleselector) {
    roleselector.show();
  })["catch"](function (err) {
    console.log('selectRoleFail', err);
    option.onError && option.onError(err);
    console.log('初始化失败', err);
  });
};
export var RoleSelector = {
  init: function init(option) {
    return new Promise(function (resolve, reject) {
      var instance;

      try {
        instance = new RoleSelectorComponent(option);
        resolve(instance);
      } catch (e) {
        console.log(e);
        reject({
          errCode: -2,
          errMsg: '角色选择模块初始化失败'
        });
      }
    });
  }
};